import { numberToPrettyString } from '@cian/utils';

export const formatMonthlyPayment = (payment?: number): string => {
  return payment ? `от ${numberToPrettyString(payment)} ₽/мес` : '—';
};
